import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './Header.css';

export default function Header() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll(); // Check initial state

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <header className={`header ${isScrolled ? 'header-scrolled' : ''}`}>
      <div className="header-container container">
        <nav className="header-nav header-nav-left">
          <Link to="/about" className="nav-link">
            Our Story
          </Link>
        </nav>
        <div className="header-logo header-logo-center">
          <Link to="/" className="header-logo-link">
            <img
              src="/kids-vids-small-banner-logo.png"
              alt="KidsVids"
              className="header-logo-image"
            />
          </Link>
        </div>
        <nav className="header-nav header-nav-right">
          <Link to="/enquiries" className="nav-link">
            Enquiries
          </Link>
        </nav>
      </div>
    </header>
  );
}
